import { useState, useEffect } from "react";

// Material-ui imports
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

export function ShipmentOptionsPurchaseOrder({
  purchaseOrder,
  purchaseOrderPattern,
  setPurchaseOrder,
  disabled,
  isPOValid,
  setIsPOValid,
  required = false,
}) {
  const [errorMessage, setErrorMessage] = useState("");

  // Validate Purchase Order
  useEffect(() => {
    validatePONumber(purchaseOrder);
  }, [purchaseOrder]);

  const handleChange = (event) => {
    validatePONumber(event.target.value);
    setPurchaseOrder(event.target.value);
  };

  const getPoNumberMatcher = (fString) => {
    if (!fString) return /.*/;
    // if the string starts with ^ and ends with $, return the string
    if (fString.startsWith("^") && fString.endsWith("$"))
      return new RegExp(fString);
    // if the string contains OR, split the string and return the regex
    if (fString.includes(" OR ")) {
      const poPatterns = fString.split(" OR ");
      let regex = "";
      poPatterns.forEach((poPattern, index) => {
        regex +=
          "^" +
          poPattern
            .replace(/[Aa]/g, "[A-Za-z]")
            .replace(/[Nn]/g, "[0-9]")
            .replace(/\//g, "\\/") +
          "$";
        if (index < poPatterns.length - 1) regex += "|";
      });
      return new RegExp(regex);
    } else {
      return new RegExp(
        "^" +
          fString
            .replace(/[Aa]/g, "[A-Za-z]")
            .replace(/[Nn]/g, "[0-9]")
            .replace(/\//g, "\\/") +
          "$",
      );
    }
  };

  const validatePONumber = (po) => {
    if (!po || po === "") {
      if (required) {
        setErrorMessage("Purchase Order cannot be blank");
        setIsPOValid(false);
      } else {
        setErrorMessage("");
        setIsPOValid(true);
      }
      return;
    }
    if (purchaseOrderPattern || purchaseOrderPattern !== "") {
      const poNumberFormat = getPoNumberMatcher(purchaseOrderPattern);
      if (!po.match(poNumberFormat)) {
        setErrorMessage(
          `Purchase Order must be in format ${purchaseOrderPattern}`,
        );
        setIsPOValid(false);
        return;
      }
    }
    setErrorMessage("");
    setIsPOValid(true);
  };

  return (
    <Box>
      <TextField
        error={!isPOValid}
        helperText={!isPOValid && errorMessage}
        id="po"
        label={
          purchaseOrderPattern
            ? `Purchase Order (${purchaseOrderPattern})`
            : "Purchase Order"
        }
        variant="outlined"
        value={purchaseOrder || ""}
        fullWidth
        disabled={disabled}
        required={required}
        onChange={handleChange}
        slotProps={{
          htmlInput: { maxLength: 20 },
        }}
      />
    </Box>
  );
}
